// components/AuthModal.js
// Propósito: Modal controlado para login/registro, con estilo glass.

import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext.js';

function AuthModal({ show, isOpen, onClose }) {
  const { login, register } = useAuth();
  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const visible = typeof isOpen === 'boolean' ? isOpen : show;
  if (!visible) return null;

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      if (mode === 'login') {
        await login(email, password);
      } else {
        await register(name, email, password);
      }
      onClose?.();
    } catch (err) {
      setError(err.message || 'Acción no disponible');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="glass-card modal-card">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex gap-2">
            <button className={`btn btn-sm ${mode === 'login' ? 'btn-primary' : 'btn-outline-light'}`} onClick={() => setMode('login')}>Iniciar sesión</button>
            <button className={`btn btn-sm ${mode === 'register' ? 'btn-primary' : 'btn-outline-light'}`} onClick={() => setMode('register')}>Registrarse</button>
          </div>
          <button className="btn btn-outline-light btn-sm" onClick={onClose} aria-label="Cerrar">✕</button>
        </div>
        {error && <div className="alert alert-danger glass-card mb-2">{error}</div>}
        <form onSubmit={handleSubmit} className="d-flex flex-column gap-2">
          {mode === 'register' && (
            <input
              type="text"
              className="form-control glass-input"
              placeholder="Nombre"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          )}
          <input
            type="email"
            className="form-control glass-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            className="form-control glass-input"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button className="btn btn-primary btn-glow" type="submit" disabled={loading}>
            {loading ? 'Procesando…' : mode === 'login' ? 'Ingresar' : 'Registrarse'}
          </button>
        </form>
        {/* Botón de Google temporalmente deshabilitado */}
      </div>
    </div>
  );
}

export default AuthModal;
